export const Table = ({
  primaryColor = '#ffd800',
  primaryFontColor = 'rgba(0,0,0,0.8)',
  secondaryColor = '#3b4046',
  isRecruiter = false,
  isManager = false,
}) => {
  return (
    <>
      {isRecruiter || isManager ? (
        <svg viewBox="0 0 973.245 817.199">
          <defs>
            <filter
              id="Rectangle_23"
              x="0"
              y="0"
              width="973.245"
              height="817.199"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="3" result="blur" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur" />
              <feComposite in="SourceGraphic" />
            </filter>
          </defs>
          <g
            id="Group_41834"
            data-name="Group 41834"
            transform="translate(975 -9444.4)"
          >
            <g
              id="Group_41833"
              data-name="Group 41833"
              transform="translate(-1850 8753.6)"
            >
              <g
                transform="matrix(1, 0, 0, 1, 875, 690.8)"
                filter="url(#Rectangle_23)"
              >
                <rect
                  id="Rectangle_23-2"
                  data-name="Rectangle 23"
                  width="955.245"
                  height="799.199"
                  rx="20"
                  transform="translate(9 6)"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_11707"
                data-name="Group 11707"
                transform="translate(2257.5 517.748)"
              >
                <rect
                  id="Rectangle_2876"
                  data-name="Rectangle 2876"
                  width="917.929"
                  height="58"
                  transform="translate(-1352 844.253)"
                  fill="#f2f2f2"
                />
                <rect
                  id="Rectangle_2877"
                  data-name="Rectangle 2877"
                  width="917.929"
                  height="58"
                  transform="translate(-1352 738.157)"
                  fill="#f2f2f2"
                />
                <rect
                  id="Rectangle_46"
                  data-name="Rectangle 46"
                  width="917.929"
                  height="58"
                  transform="translate(-1352 417.011)"
                  fill="#f2f2f2"
                />
                <rect
                  id="Rectangle_53"
                  data-name="Rectangle 53"
                  width="917.929"
                  height="58"
                  transform="translate(-1352 299)"
                  fill={secondaryColor}
                />
                <rect
                  id="Rectangle_49"
                  data-name="Rectangle 49"
                  width="917.929"
                  height="58"
                  transform="translate(-1352 631.753)"
                  fill="#f2f2f2"
                />
                <rect
                  id="Rectangle_47"
                  data-name="Rectangle 47"
                  width="917.929"
                  height="58"
                  transform="translate(-1352 524.382)"
                  fill="#f2f2f2"
                />
                <rect
                  id="Rectangle_48"
                  data-name="Rectangle 48"
                  width="917.929"
                  height="58"
                  transform="translate(-1352 739.124)"
                  fill="#f2f2f2"
                />
                <text
                  id="J00949"
                  transform="translate(-1311 395)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    J00949
                  </tspan>
                </text>
                <text
                  id="Java_Developer"
                  data-name="Java Developer"
                  transform="translate(-1122.825 395)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Java Developer
                  </tspan>
                </text>
                <text
                  id="Canada"
                  transform="translate(-906.627 395)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Canada
                  </tspan>
                </text>
                <text
                  id="Active"
                  transform="translate(-732.212 395)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Active
                  </tspan>
                </text>
                <text
                  id="TDQ"
                  transform="translate(-543.071 395)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    TDQ
                  </tspan>
                </text>
                <text
                  id="J00949-2"
                  data-name="J00949"
                  transform="translate(-1311 446.828)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    J00949
                  </tspan>
                </text>
                <text
                  id="Java_Developer-2"
                  data-name="Java Developer"
                  transform="translate(-1122.825 446.828)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Java Developer
                  </tspan>
                </text>
                <text
                  id="Canada-2"
                  data-name="Canada"
                  transform="translate(-906.627 446.828)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Canada
                  </tspan>
                </text>
                <text
                  id="Inactive"
                  transform="translate(-731.998 446.828)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Inactive
                  </tspan>
                </text>
                <text
                  id="TDQ-2"
                  data-name="TDQ"
                  transform="translate(-543.071 446.828)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    TDQ
                  </tspan>
                </text>
                <text
                  id="J00949-3"
                  data-name="J00949"
                  transform="translate(-1311 501.098)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    J00949
                  </tspan>
                </text>
                <text
                  id="Java_Developer-3"
                  data-name="Java Developer"
                  transform="translate(-1122.825 501.098)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Java Developer
                  </tspan>
                </text>
                <text
                  id="Canada-3"
                  data-name="Canada"
                  transform="translate(-906.627 501.098)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Canada
                  </tspan>
                </text>
                <text
                  id="Active-2"
                  data-name="Active"
                  transform="translate(-732.212 501.098)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Active
                  </tspan>
                </text>
                <text
                  id="TDQ-3"
                  data-name="TDQ"
                  transform="translate(-543.071 501.098)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    TDQ
                  </tspan>
                </text>
                <text
                  id="J00949-4"
                  data-name="J00949"
                  transform="translate(-1311 555.367)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    J00949
                  </tspan>
                </text>
                <text
                  id="Java_Developer-4"
                  data-name="Java Developer"
                  transform="translate(-1122.825 555.367)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Java Developer
                  </tspan>
                </text>
                <text
                  id="Canada-4"
                  data-name="Canada"
                  transform="translate(-906.627 555.367)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Canada
                  </tspan>
                </text>
                <text
                  id="Active-3"
                  data-name="Active"
                  transform="translate(-732.212 555.367)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Active
                  </tspan>
                </text>
                <text
                  id="TDQ-4"
                  data-name="TDQ"
                  transform="translate(-543.071 555.367)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    TDQ
                  </tspan>
                </text>
                <text
                  id="J00949-5"
                  data-name="J00949"
                  transform="translate(-1311 611.575)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    J00949
                  </tspan>
                </text>
                <text
                  id="Java_Developer-5"
                  data-name="Java Developer"
                  transform="translate(-1122.825 609.636)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Java Developer
                  </tspan>
                </text>
                <text
                  id="Canada-5"
                  data-name="Canada"
                  transform="translate(-906.627 609.636)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Canada
                  </tspan>
                </text>
                <text
                  id="Active-4"
                  data-name="Active"
                  transform="translate(-732.212 609.636)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Active
                  </tspan>
                </text>
                <text
                  id="TDQ-5"
                  data-name="TDQ"
                  transform="translate(-543.071 609.636)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    TDQ
                  </tspan>
                </text>
                <text
                  id="J00949-6"
                  data-name="J00949"
                  transform="translate(-1311 663.906)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    J00949
                  </tspan>
                </text>
                <text
                  id="Java_Developer-6"
                  data-name="Java Developer"
                  transform="translate(-1122.825 663.906)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Java Developer
                  </tspan>
                </text>
                <text
                  id="Canada-6"
                  data-name="Canada"
                  transform="translate(-906.627 663.906)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Canada
                  </tspan>
                </text>
                <text
                  id="Active-5"
                  data-name="Active"
                  transform="translate(-732.212 663.906)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Active
                  </tspan>
                </text>
                <text
                  id="TDQ-6"
                  data-name="TDQ"
                  transform="translate(-543.071 663.906)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    TDQ
                  </tspan>
                </text>
                <text
                  id="J00949-7"
                  data-name="J00949"
                  transform="translate(-1311 718.175)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    J00949
                  </tspan>
                </text>
                <text
                  id="Java_Developer-7"
                  data-name="Java Developer"
                  transform="translate(-1122.825 718.175)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Java Developer
                  </tspan>
                </text>
                <text
                  id="Canada-7"
                  data-name="Canada"
                  transform="translate(-906.627 718.175)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Canada
                  </tspan>
                </text>
                <text
                  id="Active-6"
                  data-name="Active"
                  transform="translate(-732.212 718.175)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Active
                  </tspan>
                </text>
                <text
                  id="TDQ-7"
                  data-name="TDQ"
                  transform="translate(-543.071 718.175)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    TDQ
                  </tspan>
                </text>
                <text
                  id="J00949-8"
                  data-name="J00949"
                  transform="translate(-1311 772.445)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    J00949
                  </tspan>
                </text>
                <text
                  id="Java_Developer-8"
                  data-name="Java Developer"
                  transform="translate(-1122.825 772.445)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Java Developer
                  </tspan>
                </text>
                <text
                  id="Canada-8"
                  data-name="Canada"
                  transform="translate(-906.627 772.445)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Canada
                  </tspan>
                </text>
                <text
                  id="Active-7"
                  data-name="Active"
                  transform="translate(-732.212 772.445)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Active
                  </tspan>
                </text>
                <text
                  id="TDQ-8"
                  data-name="TDQ"
                  transform="translate(-543.071 772.445)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    TDQ
                  </tspan>
                </text>
                <text
                  id="J00949-9"
                  data-name="J00949"
                  transform="translate(-1311 826.714)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    J00949
                  </tspan>
                </text>
                <text
                  id="Java_Developer-9"
                  data-name="Java Developer"
                  transform="translate(-1122.825 826.714)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Java Developer
                  </tspan>
                </text>
                <text
                  id="Canada-9"
                  data-name="Canada"
                  transform="translate(-906.627 826.714)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Canada
                  </tspan>
                </text>
                <text
                  id="Active-8"
                  data-name="Active"
                  transform="translate(-732.212 826.714)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Active
                  </tspan>
                </text>
                <text
                  id="TDQ-9"
                  data-name="TDQ"
                  transform="translate(-543.071 826.714)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    TDQ
                  </tspan>
                </text>
                <text
                  id="J00949-10"
                  data-name="J00949"
                  transform="translate(-1311 879.253)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    J00949
                  </tspan>
                </text>
                <text
                  id="Java_Developer-10"
                  data-name="Java Developer"
                  transform="translate(-1122.825 879.253)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Java Developer
                  </tspan>
                </text>
                <text
                  id="Canada-10"
                  data-name="Canada"
                  transform="translate(-906.627 879.253)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Canada
                  </tspan>
                </text>
                <text
                  id="Active-9"
                  data-name="Active"
                  transform="translate(-732.212 879.253)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Active
                  </tspan>
                </text>
                <text
                  id="TDQ-10"
                  data-name="TDQ"
                  transform="translate(-543.071 879.253)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    TDQ
                  </tspan>
                </text>
                <text
                  id="J00949-11"
                  data-name="J00949"
                  transform="translate(-1311 935.253)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    J00949
                  </tspan>
                </text>
                <text
                  id="Java_Developer-11"
                  data-name="Java Developer"
                  transform="translate(-1122.825 935.253)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Java Developer
                  </tspan>
                </text>
                <text
                  id="Canada-11"
                  data-name="Canada"
                  transform="translate(-906.627 935.253)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Canada
                  </tspan>
                </text>
                <text
                  id="Active-10"
                  data-name="Active"
                  transform="translate(-732.212 935.253)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    Active
                  </tspan>
                </text>
                <text
                  id="TDQ-11"
                  data-name="TDQ"
                  transform="translate(-543.071 935.253)"
                  fill="#3e3e3e"
                  font-size="16"
                  font-family="Poppins-Regular, Poppins"
                >
                  <tspan x="0" y="0">
                    TDQ
                  </tspan>
                </text>
                <text
                  id="Job_Code"
                  data-name="Job Code"
                  transform="translate(-1308 333)"
                  fill="#fff"
                  font-size="18"
                  font-family="Poppins-Medium, Poppins"
                  font-weight="500"
                >
                  <tspan x="0" y="0">
                    Job Code
                  </tspan>
                </text>
                <text
                  id="Job_Title"
                  data-name="Job Title"
                  transform="translate(-1123.126 333)"
                  fill="#fff"
                  font-size="18"
                  font-family="Poppins-Medium, Poppins"
                  font-weight="500"
                >
                  <tspan x="0" y="0">
                    Job Title
                  </tspan>
                </text>
                <text
                  id="Location"
                  transform="translate(-907.524 333)"
                  fill="#fff"
                  font-size="18"
                  font-family="Poppins-Medium, Poppins"
                  font-weight="500"
                >
                  <tspan x="0" y="0">
                    Location
                  </tspan>
                </text>
                <text
                  id="Job_Status"
                  data-name="Job Status"
                  transform="translate(-732.487 333)"
                  fill="#fff"
                  font-size="18"
                  font-family="Poppins-Medium, Poppins"
                  font-weight="500"
                >
                  <tspan x="0" y="0">
                    Job Status
                  </tspan>
                </text>
                <text
                  id="Client"
                  transform="translate(-544.071 333)"
                  fill="#fff"
                  font-size="18"
                  font-family="Poppins-Medium, Poppins"
                  font-weight="500"
                >
                  <tspan x="0" y="0">
                    Client
                  </tspan>
                </text>
              </g>
              <path
                id="Union_11"
                data-name="Union 11"
                d="M602.65,50H0V19A19,19,0,0,1,19,0H767L721.146,50Z"
                transform="translate(883 697)"
                fill={primaryColor}
              />
              <text
                id="List_of_Requirements_Assigned_to_Recruiters"
                data-name="List of Requirements Assigned to Recruiters"
                transform="translate(905.5 729.001)"
                fill={primaryFontColor}
                font-size="18"
                font-family="SegoeUI-Bold, Segoe UI"
                font-weight="700"
              >
                <tspan x="0" y="0">
                  Requirements Tracker
                </tspan>
              </text>
            </g>
            {isManager && (
              <g
                id="Group_38515"
                data-name="Group 38515"
                transform="translate(-800.668 8925.697)"
              >
                <text
                  id="Team"
                  transform="translate(727.668 610.301)"
                  font-size="16"
                  font-family="SegoeUI, Segoe UI"
                >
                  <tspan x="0" y="0">
                    Team
                  </tspan>
                </text>
                <text
                  id="Individual"
                  transform="translate(598 610.301)"
                  font-size="16"
                  font-family="SegoeUI, Segoe UI"
                >
                  <tspan x="0" y="0">
                    Individual
                  </tspan>
                </text>
                <rect
                  id="Rectangle_2910"
                  data-name="Rectangle 2910"
                  width="50"
                  height="20"
                  rx="10"
                  transform="translate(671.668 595.301)"
                  fill="#5d5d5d"
                />
                <circle
                  id="Ellipse_68"
                  data-name="Ellipse 68"
                  cx="6.5"
                  cy="6.5"
                  r="6.5"
                  transform="translate(677.668 598.801)"
                  fill={primaryColor}
                />
              </g>
            )}
          </g>
        </svg>
      ) : (
        <svg viewBox="0 0 507.43 345.977">
          <defs>
            <filter
              id="Rectangle_20650"
              x="0"
              y="0"
              width="507.43"
              height="345.977"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="3" result="blur" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur" />
              <feComposite in="SourceGraphic" />
            </filter>
            <filter
              id="Rectangle_20649"
              x="162.395"
              y="35.422"
              width="198.609"
              height="39.002"
              filterUnits="userSpaceOnUse"
            >
              <feOffset dy="3" input="SourceAlpha" />
              <feGaussianBlur stdDeviation="3" result="blur-2" />
              <feFlood flood-opacity="0.161" />
              <feComposite operator="in" in2="blur-2" />
              <feComposite in="SourceGraphic" />
            </filter>
          </defs>
          <g
            id="Group_42468"
            data-name="Group 42468"
            transform="translate(10619.315 -17787.578)"
          >
            <g
              id="Group_42465"
              data-name="Group 42465"
              transform="translate(-106 -41)"
            >
              <g
                transform="matrix(1, 0, 0, 1, -10513.32, 17828.58)"
                filter="url(#Rectangle_20650)"
              >
                <rect
                  id="Rectangle_20650-2"
                  data-name="Rectangle 20650"
                  width="489.429"
                  height="327.978"
                  rx="20"
                  transform="translate(9 6)"
                  fill="#fff"
                />
              </g>
              <path
                id="Union_77"
                data-name="Union 77"
                d="M253.127,28.861H0V19A19,19,0,0,1,19,0H322.158L302.9,28.861Z"
                transform="translate(-10506 17831.578)"
                fill={primaryColor}
              />
              <text
                id="List_of_Candidates_by_a_Specific_Status"
                data-name="List of Candidates by a Specific Status"
                transform="translate(-10484.967 17849.51)"
                fill="rgba(0,0,0,0.8)"
                font-size="9"
                font-family="Roboto-Bold, Roboto"
                font-weight="700"
              >
                <tspan x="0" y="0" fill={primaryFontColor}>
                  List of Candidates by a Specific Status
                </tspan>
              </text>
              <g
                id="Group_42463"
                data-name="Group 42463"
                transform="translate(-10486.612 17900.461)"
              >
                <rect
                  id="Rectangle_53"
                  data-name="Rectangle 53"
                  width="448.974"
                  height="24.361"
                  transform="translate(0 0)"
                  fill={secondaryColor}
                />
                <text
                  id="Applicant_Name"
                  data-name="Applicant Name"
                  transform="translate(11.965 13.826)"
                  fill="#fff"
                  font-size="7"
                  font-family="Roboto-Medium, Roboto"
                  font-weight="500"
                >
                  <tspan x="0" y="0">
                    Applicant Name
                  </tspan>
                </text>
                <text
                  id="Job_Title"
                  data-name="Job Title"
                  transform="translate(104.376 13.826)"
                  fill="#fff"
                  font-size="7"
                  font-family="Roboto-Medium, Roboto"
                  font-weight="500"
                >
                  <tspan x="0" y="0">
                    Job Title
                  </tspan>
                </text>
                <text
                  id="Last_Updated"
                  data-name="Last Updated"
                  transform="translate(179.02 14.68)"
                  fill="#fff"
                  font-size="7"
                  font-family="Roboto-Medium, Roboto"
                  font-weight="500"
                >
                  <tspan x="0" y="0">
                    Last Updated
                  </tspan>
                </text>
                <text
                  id="Recruiter_Name"
                  data-name="Recruiter Name"
                  transform="translate(260.204 13.826)"
                  fill="#fff"
                  font-size="7"
                  font-family="Roboto-Medium, Roboto"
                  font-weight="500"
                >
                  <tspan x="0" y="0">
                    Recruiter Name
                  </tspan>
                </text>
                <text
                  id="Client"
                  transform="translate(339.168 13.826)"
                  fill="#fff"
                  font-size="7"
                  font-family="Roboto-Medium, Roboto"
                  font-weight="500"
                >
                  <tspan x="0" y="0">
                    Client
                  </tspan>
                </text>
                <text
                  id="Status"
                  transform="translate(397.672 13.826)"
                  fill="#fff"
                  font-size="7"
                  font-family="Roboto-Medium, Roboto"
                  font-weight="500"
                >
                  <tspan x="0" y="0">
                    Status
                  </tspan>
                </text>
                <g
                  id="Group_42425"
                  data-name="Group 42425"
                  transform="translate(0 32.93)"
                >
                  <text
                    id="John_Doe"
                    data-name="John Doe"
                    transform="translate(24.499 6.42)"
                    fill="#3e3e3e"
                    font-size="6"
                    font-family="Roboto-Regular, Roboto"
                  >
                    <tspan x="0" y="0">
                      John Doe
                    </tspan>
                  </text>
                  <text
                    id="Java_Developer"
                    data-name="Java Developer"
                    transform="translate(96.329 6.42)"
                    fill="#3e3e3e"
                    font-size="6"
                    font-family="Roboto-Regular, Roboto"
                  >
                    <tspan x="0" y="0">
                      Java Developer
                    </tspan>
                  </text>
                  <text
                    id="Sep_09_2025_15:51"
                    data-name="Sep 09 2025 15:51"
                    transform="translate(179.493 5.42)"
                    fill="#3e3e3e"
                    font-size="5"
                    font-family="Roboto-Regular, Roboto"
                  >
                    <tspan x="0" y="0">
                      Sep 09 2025 15:51
                    </tspan>
                  </text>
                  <text
                    id="Shruti_Reddy"
                    data-name="Shruti Reddy"
                    transform="translate(267.698 6.42)"
                    fill="#3e3e3e"
                    font-size="6"
                    font-family="Roboto-Regular, Roboto"
                  >
                    <tspan x="0" y="0">
                      Shruti Reddy
                    </tspan>
                  </text>
                  <text
                    id="TDQ"
                    transform="translate(342.462 6.42)"
                    fill="#3e3e3e"
                    font-size="6"
                    font-family="Roboto-Regular, Roboto"
                  >
                    <tspan x="0" y="0">
                      TDQ
                    </tspan>
                  </text>
                  <text
                    id="Pending"
                    transform="translate(395.385 7)"
                    font-size="7"
                    font-family="Roboto-Medium, Roboto"
                    font-weight="500"
                  >
                    <tspan x="0" y="0">
                      Pending
                    </tspan>
                  </text>
                  <rect
                    id="Rectangle_20595"
                    data-name="Rectangle 20595"
                    width="450.655"
                    height="24.361"
                    transform="translate(0 18.901)"
                    fill="#f2f2f2"
                  />
                  <rect
                    id="Rectangle_20596"
                    data-name="Rectangle 20596"
                    width="450.655"
                    height="24.361"
                    transform="translate(0 43.262)"
                    fill="#fff"
                  />
                  <rect
                    id="Rectangle_20597"
                    data-name="Rectangle 20597"
                    width="450.655"
                    height="24.361"
                    transform="translate(0 67.624)"
                    fill="#f2f2f2"
                  />
                  <rect
                    id="Rectangle_20598"
                    data-name="Rectangle 20598"
                    width="450.655"
                    height="24.361"
                    transform="translate(0 91.985)"
                    fill="#fff"
                  />
                  <rect
                    id="Rectangle_20599"
                    data-name="Rectangle 20599"
                    width="450.655"
                    height="24.361"
                    transform="translate(0 116.346)"
                    fill="#f2f2f2"
                  />
                  <rect
                    id="Rectangle_20647"
                    data-name="Rectangle 20647"
                    width="450.655"
                    height="24.361"
                    transform="translate(-0.385 165.069)"
                    fill="#f2f2f2"
                  />
                  <rect
                    id="Rectangle_20600"
                    data-name="Rectangle 20600"
                    width="450.655"
                    height="24.361"
                    transform="translate(0 140.708)"
                    fill="#fff"
                  />
                  <rect
                    id="Rectangle_20602"
                    data-name="Rectangle 20602"
                    width="450.655"
                    height="24.361"
                    transform="translate(0 189.43)"
                    fill="#fff"
                  />
                  <g
                    id="Group_42416"
                    data-name="Group 42416"
                    transform="translate(24.499 26.041)"
                  >
                    <text
                      id="John_Doe-2"
                      data-name="John Doe"
                      transform="translate(0 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        John Doe
                      </tspan>
                    </text>
                    <text
                      id="Java_Developer-2"
                      data-name="Java Developer"
                      transform="translate(71.83 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Java Developer
                      </tspan>
                    </text>
                    <text
                      id="Sep_09_2025_15:51-2"
                      data-name="Sep 09 2025 15:51"
                      transform="translate(154.994 5.42)"
                      fill="#3e3e3e"
                      font-size="5"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Sep 09 2025 15:51
                      </tspan>
                    </text>
                    <text
                      id="Shruti_Reddy-2"
                      data-name="Shruti Reddy"
                      transform="translate(243.199 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Shruti Reddy
                      </tspan>
                    </text>
                    <text
                      id="HCL"
                      transform="translate(317.963 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        HCL
                      </tspan>
                    </text>
                    <text
                      id="Pending-2"
                      data-name="Pending"
                      transform="translate(370.886 7)"
                      font-size="7"
                      font-family="Roboto-Medium, Roboto"
                      font-weight="500"
                    >
                      <tspan x="0" y="0">
                        Pending
                      </tspan>
                    </text>
                  </g>
                  <g
                    id="Group_42417"
                    data-name="Group 42417"
                    transform="translate(24.499 50.403)"
                  >
                    <text
                      id="John_Doe-3"
                      data-name="John Doe"
                      transform="translate(0 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        John Doe
                      </tspan>
                    </text>
                    <text
                      id="Java_Developer-3"
                      data-name="Java Developer"
                      transform="translate(71.83 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Java Developer
                      </tspan>
                    </text>
                    <text
                      id="Sep_09_2025_15:51-3"
                      data-name="Sep 09 2025 15:51"
                      transform="translate(154.994 5.42)"
                      fill="#3e3e3e"
                      font-size="5"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Sep 09 2025 15:51
                      </tspan>
                    </text>
                    <text
                      id="Shruti_Reddy-3"
                      data-name="Shruti Reddy"
                      transform="translate(243.199 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Shruti Reddy
                      </tspan>
                    </text>
                    <text
                      id="Myntra"
                      transform="translate(313.963 5.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Myntra
                      </tspan>
                    </text>
                    <text
                      id="Pending-3"
                      data-name="Pending"
                      transform="translate(370.886 7)"
                      font-size="7"
                      font-family="Roboto-Medium, Roboto"
                      font-weight="500"
                    >
                      <tspan x="0" y="0">
                        Pending
                      </tspan>
                    </text>
                  </g>
                  <g
                    id="Group_42418"
                    data-name="Group 42418"
                    transform="translate(24.499 74.764)"
                  >
                    <text
                      id="John_Doe-4"
                      data-name="John Doe"
                      transform="translate(0 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        John Doe
                      </tspan>
                    </text>
                    <text
                      id="Java_Developer-4"
                      data-name="Java Developer"
                      transform="translate(71.83 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Java Developer
                      </tspan>
                    </text>
                    <text
                      id="Sep_09_2025_15:51-4"
                      data-name="Sep 09 2025 15:51"
                      transform="translate(154.994 5.42)"
                      fill="#3e3e3e"
                      font-size="5"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Sep 09 2025 15:51
                      </tspan>
                    </text>
                    <text
                      id="Shruti_Reddy-4"
                      data-name="Shruti Reddy"
                      transform="translate(243.199 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Shruti Reddy
                      </tspan>
                    </text>
                    <text
                      id="XYZ"
                      transform="translate(317.963 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        XYZ
                      </tspan>
                    </text>
                    <text
                      id="Pending-4"
                      data-name="Pending"
                      transform="translate(370.886 7)"
                      font-size="7"
                      font-family="Roboto-Medium, Roboto"
                      font-weight="500"
                    >
                      <tspan x="0" y="0">
                        Pending
                      </tspan>
                    </text>
                  </g>
                  <g
                    id="Group_42419"
                    data-name="Group 42419"
                    transform="translate(24.499 99.125)"
                  >
                    <text
                      id="John_Doe-5"
                      data-name="John Doe"
                      transform="translate(0 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        John Doe
                      </tspan>
                    </text>
                    <text
                      id="Java_Developer-5"
                      data-name="Java Developer"
                      transform="translate(71.83 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Java Developer
                      </tspan>
                    </text>
                    <text
                      id="Sep_09_2025_15:51-5"
                      data-name="Sep 09 2025 15:51"
                      transform="translate(154.994 5.42)"
                      fill="#3e3e3e"
                      font-size="5"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Sep 09 2025 15:51
                      </tspan>
                    </text>
                    <text
                      id="Shruti_Reddy-5"
                      data-name="Shruti Reddy"
                      transform="translate(243.199 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Shruti Reddy
                      </tspan>
                    </text>
                    <text
                      id="TDQ-2"
                      data-name="TDQ"
                      transform="translate(317.963 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        TDQ
                      </tspan>
                    </text>
                    <text
                      id="Pending-5"
                      data-name="Pending"
                      transform="translate(370.886 7)"
                      font-size="7"
                      font-family="Roboto-Medium, Roboto"
                      font-weight="500"
                    >
                      <tspan x="0" y="0">
                        Pending
                      </tspan>
                    </text>
                  </g>
                  <g
                    id="Group_42420"
                    data-name="Group 42420"
                    transform="translate(24.499 123.487)"
                  >
                    <text
                      id="John_Doe-6"
                      data-name="John Doe"
                      transform="translate(0 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        John Doe
                      </tspan>
                    </text>
                    <text
                      id="Java_Developer-6"
                      data-name="Java Developer"
                      transform="translate(71.83 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Java Developer
                      </tspan>
                    </text>
                    <text
                      id="Sep_09_2025_15:51-6"
                      data-name="Sep 09 2025 15:51"
                      transform="translate(154.994 5.42)"
                      fill="#3e3e3e"
                      font-size="5"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Sep 09 2025 15:51
                      </tspan>
                    </text>
                    <text
                      id="Shruti_Reddy-6"
                      data-name="Shruti Reddy"
                      transform="translate(243.199 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Shruti Reddy
                      </tspan>
                    </text>
                    <text
                      id="TDQ-3"
                      data-name="TDQ"
                      transform="translate(317.963 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        TDQ
                      </tspan>
                    </text>
                    <text
                      id="Associated"
                      transform="translate(365.886 7.42)"
                      font-size="7"
                      font-family="Roboto-Medium, Roboto"
                      font-weight="500"
                    >
                      <tspan x="0" y="0">
                        Associated
                      </tspan>
                    </text>
                  </g>
                  <g
                    id="Group_42421"
                    data-name="Group 42421"
                    transform="translate(24.499 147.848)"
                  >
                    <text
                      id="John_Doe-7"
                      data-name="John Doe"
                      transform="translate(0 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        John Doe
                      </tspan>
                    </text>
                    <text
                      id="Java_Developer-7"
                      data-name="Java Developer"
                      transform="translate(71.83 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Java Developer
                      </tspan>
                    </text>
                    <text
                      id="Sep_09_2025_15:51-7"
                      data-name="Sep 09 2025 15:51"
                      transform="translate(154.994 5.42)"
                      fill="#3e3e3e"
                      font-size="5"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Sep 09 2025 15:51
                      </tspan>
                    </text>
                    <text
                      id="Shruti_Reddy-7"
                      data-name="Shruti Reddy"
                      transform="translate(243.199 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Shruti Reddy
                      </tspan>
                    </text>
                    <text
                      id="TDQ-4"
                      data-name="TDQ"
                      transform="translate(317.963 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        TDQ
                      </tspan>
                    </text>
                    <text
                      id="Pending-6"
                      data-name="Pending"
                      transform="translate(370.886 7)"
                      font-size="7"
                      font-family="Roboto-Medium, Roboto"
                      font-weight="500"
                    >
                      <tspan x="0" y="0">
                        Pending
                      </tspan>
                    </text>
                  </g>
                  <g
                    id="Group_42462"
                    data-name="Group 42462"
                    transform="translate(24.499 172.75)"
                  >
                    <text
                      id="John_Doe-8"
                      data-name="John Doe"
                      transform="translate(0 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        John Doe
                      </tspan>
                    </text>
                    <text
                      id="Java_Developer-8"
                      data-name="Java Developer"
                      transform="translate(71.83 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Java Developer
                      </tspan>
                    </text>
                    <text
                      id="Sep_09_2025_15:51-8"
                      data-name="Sep 09 2025 15:51"
                      transform="translate(154.994 5.42)"
                      fill="#3e3e3e"
                      font-size="5"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Sep 09 2025 15:51
                      </tspan>
                    </text>
                    <text
                      id="Shruti_Reddy-8"
                      data-name="Shruti Reddy"
                      transform="translate(243.199 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        Shruti Reddy
                      </tspan>
                    </text>
                    <text
                      id="TDQ-5"
                      data-name="TDQ"
                      transform="translate(317.963 6.42)"
                      fill="#3e3e3e"
                      font-size="6"
                      font-family="Roboto-Regular, Roboto"
                    >
                      <tspan x="0" y="0">
                        TDQ
                      </tspan>
                    </text>
                    <text
                      id="Pending-7"
                      data-name="Pending"
                      transform="translate(370.886 7)"
                      font-size="7"
                      font-family="Roboto-Medium, Roboto"
                      font-weight="500"
                    >
                      <tspan x="0" y="0">
                        Pending
                      </tspan>
                    </text>
                  </g>
                </g>
              </g>
              <g
                transform="matrix(1, 0, 0, 1, -10513.32, 17828.58)"
                filter="url(#Rectangle_20649)"
              >
                <g
                  id="Rectangle_20649-2"
                  data-name="Rectangle 20649"
                  transform="translate(171.39 41.42)"
                  fill="#fff"
                  stroke="#d1d1d1"
                  stroke-width="0.3"
                >
                  <rect
                    width="180.61"
                    height="21.001"
                    rx="10.501"
                    stroke="none"
                  />
                  <rect
                    x="0.15"
                    y="0.15"
                    width="180.31"
                    height="20.701"
                    rx="10.351"
                    fill="none"
                  />
                </g>
              </g>
              <text
                id="Search_By_Applicant_Name_Job_Title_Recruiter_Name_Client_Status"
                data-name="Search By Applicant Name, Job Title, Recruiter Name, Client,Status"
                transform="translate(-10333.101 17882.5)"
                fill="#9e9e9e"
                font-size="5"
                font-family="Roboto-Regular, Roboto"
              >
                <tspan x="0" y="0">
                  Search By Applicant Name, Job Title, Recruiter Name,
                  Client,Status
                </tspan>
              </text>
              <g
                id="Group_42464"
                data-name="Group 42464"
                transform="translate(-10086.664 18135.422)"
              >
                <g
                  id="Group_11651"
                  data-name="Group 11651"
                  transform="translate(0 0)"
                >
                  <g
                    id="Group_2210"
                    data-name="Group 2210"
                    transform="translate(32.729 1.842)"
                  >
                    <g
                      id="Group_2113"
                      data-name="Group 2113"
                      transform="translate(0 0)"
                    >
                      <path
                        id="Polygon_3"
                        data-name="Polygon 3"
                        d="M3.164,1.573a1,1,0,0,1,1.748,0L7.251,5.783a1,1,0,0,1-.874,1.486H1.7A1,1,0,0,1,.825,5.783Z"
                        transform="translate(17.978 0) rotate(90)"
                        fill="#454545"
                      />
                      <path
                        id="Polygon_4"
                        data-name="Polygon 4"
                        d="M3.164,1.573a1,1,0,0,1,1.748,0L7.251,5.783a1,1,0,0,1-.874,1.486H1.7A1,1,0,0,1,.825,5.783Z"
                        transform="translate(0 8.076) rotate(-90)"
                        fill="#cbcbcb"
                      />
                    </g>
                  </g>
                  <ellipse
                    id="Ellipse_46"
                    data-name="Ellipse 46"
                    cx="5.88"
                    cy="5.88"
                    rx="5.88"
                    ry="5.88"
                    fill="#e7e7e7"
                  />
                  <text
                    id="_1_2_3"
                    data-name="1      2      3"
                    transform="translate(5.04 7.602)"
                    fill="#5d5d5d"
                    fontSize="5"
                    fontFamily="Poppins-Regular, Poppins"
                  >
                    <tspan x="0" y="0" xmlSpace="preserve">
                      1 2 3
                    </tspan>
                  </text>
                </g>
              </g>
            </g>
            <g
              id="Group_42466"
              data-name="Group 42466"
              transform="translate(-10286.736 17834.184)"
            >
              <g
                id="Ellipse_9"
                data-name="Ellipse 9"
                fill="#fff"
                stroke="#cbcbcb"
                stroke-width="1"
              >
                <ellipse
                  cx="4.41"
                  cy="4.41"
                  rx="4.41"
                  ry="4.41"
                  stroke="none"
                />
                <ellipse cx="4.41" cy="4.41" rx="3.91" ry="3.91" fill="none" />
              </g>
              <path
                id="Path_6"
                data-name="Path 6"
                d="M0,0,3.856,3.593"
                transform="translate(7.4 7.039)"
                fill="none"
                stroke="#cbcbcb"
                stroke-width="1"
              />
            </g>
          </g>
        </svg>
      )}
    </>
  );
};
